<template>
  <CollapseTransition>
    <div
      class="bg-negative text-white q-mt-sm q-pa-xs full-width text-bold"
      style="border-radius: 3px"
      v-show="autoRejection"
    >
      <center><small>Recebimento de atendimentos bloqueado</small></center>
    </div>
  </CollapseTransition>
</template>

<script>
import { mapState } from 'vuex'
import { CollapseTransition } from '@ivanv/vue-collapse-transition'

export default {
  components: {
    CollapseTransition
  },

  computed: {
    ...mapState({
      autoRejection: ({ agentModule }) => Boolean(agentModule?.autoRejection)
    })
  }
}
</script>
